import { get } from './service';
import { config } from '../Constants';

const APIURL_AUTH = config.url.API_URL + '/login';

const getDataPath = (params) => {
	const versionId = params && params.versionId ? params.versionId : -1;
	let dataPath = '/data';

	if ([7, 8, 9].includes(versionId)) {
		dataPath = '/verbalData';
	} else if ([10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25].includes(versionId)) {
		dataPath = '/nonverbalData';
	} else if ([26, 27, 28, 29, 30, 31, 32].includes(versionId)) {
		dataPath = '/quantData';
	}

	return config.url.API_URL + dataPath;
};

export const userLogin = (params, successFunc, errorFunc, finallFunc) => get(APIURL_AUTH, params, successFunc, errorFunc, finallFunc);
export const getData = (params, successFunc, errorFunc, finallFunc) => get(getDataPath(params), null, successFunc, errorFunc, finallFunc);